import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { protectedResources } from '../auth-config';

@Injectable({
    providedIn: 'root'
})
export class SignedDoctorService {
    url = protectedResources.starhealthapi.endpoint;
    constructor(private http: HttpClient) { }

    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    getAll(search: string, order: string, page: number, pageSize: number) {
        return this.http.get<any>(
            `${this.url}/SignedDoctor/getAll?search=${search}&order=${order}&page=${page}&max=${pageSize}`
        );
    }

    add(model: any){
        return this.http.post<any>(`${this.url}/SignedDoctor/add`, model, { headers: this.headers })
        .pipe(map((res: any) => res));
    }

    edit(employeeId: string, model: any){
        return this.http.put<any>(`${this.url}/SignedDoctor/edit/${employeeId}`, model, { headers: this.headers })
        .pipe(map((res: any) => res));
    }

    getByEmployeeId(employeeId: string) {
    return this.http.get<any>(`${this.url}/SignedDoctor/getByEmployeeId/${employeeId}`)
        .pipe(map((res: any) => res));
    }

    uploadSignDoctor(model: any) {
        return this.http.post<any>(`${this.url}/SignedDoctor/Upload`, model, { headers: this.headers })
        .pipe(map((res: any) => res));
    }

    deleteByEmployeeId(employeeId: string) {
      return this.http.delete<any>(`${this.url}/SignedDoctor/${employeeId}`, { headers: this.headers })
        .pipe(map((res: any) => res));
    }
}